import { render, staticRenderFns } from "./chatHistory.vue?vue&type=template&id=894b7eba"
import script from "./chatHistory.vue?vue&type=script&lang=js"
export * from "./chatHistory.vue?vue&type=script&lang=js"
import style0 from "./chatHistory.vue?vue&type=style&index=0&id=894b7eba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports